import React from "react";

import "./Element_top_service.scss";
import { Link } from "react-router-dom";
const Element_top_service = (props) => {
  return (
    <div className="main_frame_banner_service">
      <div className="frame_banner_service">
        <div className="frame_content_banner_service">
          <h1>{props.question}</h1>
          <h2>Đã có Tien Dung Finance !</h2>
          <h3>{props.request}</h3>

          <div className="frame_button_banner_service">
            <Link to="/Consult">
              <button>Đăng ký ngay!</button>
            </Link>
          </div>
        </div>

        <div className={props.className}>
          <img src={props.image} alt="" />
        </div>
      </div>

      <div className="frame_title_service">
        <h1>{props.introduce}</h1>
        <h3>{props.last_introduce}</h3>
      </div>
    </div>
  );
};

export default Element_top_service;
